// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import PreloadImage from "../core/components/PreloadImage";
/* START-USER-IMPORTS */
import { assetsToLoad } from '../assets-to-load';
import { app } from '../core/App';
import { SceneData, TransitionPoint } from '../rooting';
/* END-USER-IMPORTS */

export default class PreloadCartoonNetwork extends BaseScene {

  constructor() {
    super("PreloadCartoonNetwork");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    const bg = this.add.image(960, 384, "preloader-cartoon-network", "preloader-bg.png");

    // preloaderBg
    const preloaderBg = this.add.image(960, 516, "preloader-cartoon-network", "preloader-fill.png");

    // preloadBar
    const preloadBar = this.add.image(966, 516, "preloader-cartoon-network", "preloader-mask.png");
    preloadBar.tintFill = true;
    preloadBar.tintTopLeft = 0;
    preloadBar.tintTopRight = 0;
    preloadBar.tintBottomLeft = 0;
    preloadBar.tintBottomRight = 0;

    // outline
    const outline = this.add.image(960, 516, "preloader-cartoon-network", "preloader-border.png");

    // mask
    const mask = this.add.image(960, 516, "preloader-cartoon-network", "preloader-mask.png");
    mask.visible = false;

    // preloadBar (components)
    new PreloadImage(preloadBar);

    this.bg = bg;
    this.preloaderBg = preloaderBg;
    this.preloadBar = preloadBar;
    this.outline = outline;
    this.mask = mask;

    this.events.emit("scene-awake");
  }

  private bg!: Phaser.GameObjects.Image;
  private preloaderBg!: Phaser.GameObjects.Image;
  private preloadBar!: Phaser.GameObjects.Image;
  private outline!: Phaser.GameObjects.Image;
  private mask!: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  // Write your code here

  public preload() {
    this.editorCreate();

    let mask = new Phaser.Display.Masks.BitmapMask(this, this.mask);
    this.preloaderBg.mask = mask;

    assetsToLoad(this);

    this.load.once(Phaser.Loader.Events.COMPLETE, this.postload, this);
  }

  public postload() {
    super.postload();

    // TODO: Loading time currently too quick so it makes a lot of flashing at start. Ideally we would wait a minimum
    // of a second rather than "load + 1 second".
    this.time.delayedCall(1000, this.finish, [], this);
    // this.finish();
  }

  public create() {
    this.load.off(Phaser.Loader.Events.COMPLETE, this.postload, this);
  }

  protected finish() {
    app.afterPreload(() => {
      app.gotoNextScene(this, TransitionPoint.PreloadEnd, {
        sourceScene: this.scene.key
      } as SceneData);
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
